//Each object within the all encompasing object, is named after their respective
export const sv = {
    newUser: {
        continueBtn: 'Fortsätt',
        h1: 'Välkommen till Funki!',
        h2: 'För att göra din upplevelse så bra som möjligt, börja med att välja dina inställningar.'
    },
    admin: {
        customersRouteBtn: 'Kunder',
        soundbankSoundsRouteBtn: 'Ljudbank och låtar',
        usersRouteBtn: 'Användare',

        customersTable: {
            alerts: {
                removeSuccess: 'Tog bort',
                removeError: 'Misslyckades med att ta bort',
                addSuccess: 'Lade till',
                updateSuccess: 'Uppdaterade',
                updateError: `Misslyckades med att uppdatera kund. Error-meddelande`
            },

            mainHeading: 'Kunder',
            paymentPlanHeaderName: 'Betalplan',
            paymentMethodHeaderName: 'Betalmetod',
            licenseStartHeaderName: 'Licensstart',
            licenseExpireHeaderName: 'Licensutgång',
            instrumentsHeaderName: 'Instrument',
            soundpackagesHeaderName: 'Låtpaket',
            actionsHeaderName: 'Actions',
            idHeaderName: 'Id',
            aliasHeaderName: 'Alias',
            contactEmailHeaderName: 'Email för kontakt',

            gridActionCopyActivationCode: 'Kopiera aktiveringskod',
            gridActionSave: 'Spara',
            gridActionCancel: 'Avbryt',
            gridActionEditSongPackage: 'Redigera låtpaket',
            gridActionDelete: 'Radera',
            gridActionEdit: 'Redigera',
            gridActionEditInstrument: 'Redigera instrument'
        },

        customersToolbar: {
            openDialogHeading: 'Handling misslyckades',
            openDialogText: 'Misslyckades att skapa ny kund då ett nytt kund-id inte kunde genereras från databasen.',
            closeDialogBtn: 'Okej'
        },

        editInstrumentsDialog: {
            heading: 'Redigera instrument för',
            form: {
                deviceIdLabel: 'Enhetens ID',
                instrumentType: 'Typ',
                submitBtn: 'Lägg till instrument'
            },
            removeBtn: 'Ta bort',
            saveBtn: 'Spara',
            cancelBtn: 'Avbryt'
        },

        editPackage: {
            heading: 'Redigera låtpaket',
            form: {
                submitBtn: 'Lägg till låtpaket'
            },
            packageNameText: 'Paketnamn',
            removeBtn: 'Ta bort',
            saveBtn: 'Spara',
            cancelBtn: 'Avbryt'
        },

        editSongPackageDialog: {
            heading: 'Redigera låtpaket för',
            form: {
                submitBtn: 'Lägg till låtpaket'
            },
            packageNameLabel: 'Paketnamn',
            removeBtn: 'Ta bort',
            saveBtn: 'Spara',
            cancelBtn: 'Avbryt'
        },

        songsAndSoundsTable: {
            heading: 'Låtar och ljud',

            IdHeader: 'Id',
            TitleHeader: 'Titel',
            ImageHeader: 'Bild',
            DescriptionHeader: 'Beskrivning',
            TypeHeader: 'Typ',
            SongPackageHeader: 'Låtpaket',
            CategoryHeader: 'Kategori',
            ArtistHeader: 'Artist',
            GenreHeader: 'Genre',
            KeyHeader: 'Tonart',
            TempoHeader: 'Tempo',
            SectionsHeader: 'Sektioner',
            BackingTrackHeader: 'Backingtrack',
            ActionsHeader: 'Actions',

            gridActionSave: 'Spara',
            gridActionCancel: 'Avbryt',
            gridActionDelete: 'Radera',
            gridActionEdit: 'Redigera',
            gridActionAddImage: 'Lägg till bild',
            gridActionSongPackage: 'Paket'
        },

        songsAndSoundsToolbar: {
            failedAction: 'Handlingen misslyckades',
            failedPostCreation: 'Misslyckades att skapa ny låtpost då ett nytt låt-id inte kunde genereras från databasen.',

            addSongBtn: 'Lägg till låt',
            closeDialogBtn: 'Okej'
        },

        userInfoDialog: {
            heading: 'Info - Utökad hantering av användare',
            infoText: 'För tillfället går det inte att utföra handlingar såsom att radera användarkonton, ändra email, etc, från detta admin-gränssnitt. Sådana handlingar kan endast utföras i Firebase-konsolen:',
            closeDialogBtn: 'Okej'
        },
        usersTable: {
            alerts: {
                success: 'Uppdaterade användare',
                error: 'Misslyckades att uppdatera användare. Error-meddelande:'
            },

            iDHeader: 'Id',
            nameHeader: 'Namn',
            emailHeader: 'Email',
            connectedCustomerId: 'Kopplad kundlicens',
            customerAliasHeader: 'Kundalias',
            createdHeader: 'Skapat',
            lastSignedInHeader: 'Senast inloggad',
            adminHeader: 'Admin',
            actionsHeader: 'Actions',

            gridActionSave: 'Spara',
            gridActionCancel: 'Avbryt',
            gridActionEdit: 'Redigera',
            gridActionInfo: 'Info',

            usersHeading: 'Användare'
        }
    },

    //Main App
    components: {
        navbar: {
            logoutBtn: 'Logga ut',
            homeRouteBtn: 'Hem',
            libraryRouteBtn: 'Bibliotek'
        },
        header: {
            activateAccountRouteBtn: 'Aktivera konto',
            loginRouteBtn: 'Logga in',
            headingSettings: 'Inställningar'
        },
        currentlyPlaying: {
            textGenre: 'Genre',
            textKey: 'Tonart',
            textTempo: 'Tempo'
        },
        changePassword: {
            form: {
                currentPasswordLabel: 'Nuvarande lösenord',
                newPasswordLabel: 'Nytt lösenord',
                submitBtn: 'Ändra lösenord',
                validation: {
                    alerts: {
                        success: 'Lösenordet har ändrats',
                        validationFail: 'Det finns fel i formuläret nedan',
                        userPasswordError1: 'Angivna nuvarande lösenordet är felaktigt',
                        userPasswordError2: 'Ogiltigt lösenord',
                        weakPassword: 'Lösenordet är för svagt eller vanligt, välj ett annat nytt lösenord',
                        firebaseError: 'Misslyckades att ändra lösenordet...',
                        generalError: 'Misslyckades att ändra lösenordet...'
                    }
                }
            }
        },
        card: {
            albumCoverImgAlt: 'Skivomslag',
            playingLabel: 'Spelas',
            keyText: 'Tonart:',
            composer: 'Kompositör:s',
            backgroundTrackText: 'Bakgrundsspår:',
            backgroundTrackYesText: 'Ja'
        }
    },

    assetsComponents: {
        menuWithContent: {
            h3UserGreeting: 'Välkommen',
            settingsBtn: 'Inställningar',

            libraryHeading: 'Bibliotek',
            evaluationHeading: 'Utvärdering',

            homeRouteBtn: 'Hem',
            musicRouteBtn: 'Musik',
            soundscapesRouteBtn: 'Ljudlandskap',
            keysRouteBtn: 'Tonarter',
            libraryRouteBtn: 'Bibliotek',
            activateAccountRouteBtn: 'Aktivera Konto',
            loginRouteBtn: 'Logga in',

            evaluationRouteBtnPre: 'Före',
            evaluationRouteBtnAfter: 'Efter',
            evaluationRouteBtnFull: 'Full'
        },
        evaluationActiveModal: {
            dialogTitle: 'Det finns en pågående utvärdering',
            dialogContentText: 'Vad vill du göra?',
            newCheckinBtn: 'Starta ny incheckning',
            continueCheckoutBtn: 'Fortsätt med utcheckning'
        },
        evaluationTypeModal: {
            dialogTitle: 'Hur många känslor ska det gå att välja mellan?',
            dialogContentText: 'Vid 3 känslor väljer man genom att trycka på en symbol och vid 5 känslor väljer man genom att dra i en slider.'
        },
        evaluationStageModal: {
            dialogTitle: 'Vilken typ av utvärdering vill du göra?',
            dialogContentText: 'Du kan välja mellan enkel ( 1 fråga ) eller expanderad (flera frågor).'
        },
        evaluationBtn: {
            btnA: 'Starta Utvärdering',
            btnB: 'Fortsätt Utvärdering'
        },
        backForwardButtonBox: {
            endBtn: 'AVSLUTA'
        }
    },

    home: {
        masterVolume: {
            paragraphMaster: 'Master volym'
        },
        instruments: {
            headingWaiting: 'Väntar på Funki instrument'
        },
        instrumentInformation: {
            paragraphSound: 'Ljud',
            paragraphMusic: 'Musik',
            paragraphSoundscape: 'Ljudlandskap',
            paragraphKey: 'Tonart',
            paragraphChooseSound: 'Välj Ljud',
            headingChooseSound: 'Välj Ljud'
        },
        touchAlternateMode: {
            easyBtn: 'Lätt',
            hardBtn: 'Svårt'
        }
    },

    library: {
        libraryComponent: {
            searchTermMusic: 'Musik',
            searchTermSoundscapes: 'Ljudlandskap',
            searchTermKeys: 'Tonarter',
            musicRouteBtn: 'Musik',
            soundscapesRouteBtn: 'Ljudlandskap',
            keysRouteBtn: 'Tonart',
            searchbarPlaceholder: 'Sök efter %{displayedSearchTerm}',
            categoryAll: 'Alla'
        },
        cetegorySelector: {},
        chooseSong: {},
        displayedCards: {
            tableCellName: 'Namn',
            tableCellProducer: 'Producent',
            tableCellKey: 'Tonart',
            tableCellScale: 'Skala'
        }
    },

    settings: {
        accountRouteBtn: 'Konto',
        licenseRouteBtn: 'Licens',
        logoutBtn: 'Logga ut',
        aboutRouteBtn: 'Om',
        adminRouteBtn: 'Admin',

        account: {
            headingEmail: 'Kopplad Mailadress',
            headingPassword: 'Lösenord',
            accordionPassword: 'Ändra Lösenord',
            headingLicense: 'Licens som kopplats',
            headingNoLicense: 'Licens som kopplats',
            bodyNoLicense: 'Ditt konto är inte kopplat till en licens ännu',
            connectLicenseRouteBtn: 'Koppla en licens',
            changeLanguage: 'Språk'
        },

        license: {
            headingOwner: 'Licensägare',
            headingPaymentPlan: 'Betalplan',
            headingConnectedInstruments: 'Instrument som har kopplats',
            bodyConnectedInstruments: 'Inga instrument har kopplats',
            boxActive: 'Aktiv',
            resetWifiPasswordBtn: 'Återställ WiFi-lösenord'
        }
    },

    evaluationTool: {
        evaluationStart: {
            startBtnBefore: 'STARTA NY INCHECKNING',
            startBtnAfter: 'STARTA NY UTCHECKNING',
            startBtnFull: 'STARTA NY UTVÄRDERING',

            imgAltA: 'börja',
            imgAltB: 'utvärdering'
        },
        evaluationQuestion: {
            forwardBtn: 'FORTSÄTT',
            questionBeforeAfter: 'HUR MÅR DU?',
            questionsFull: {
                question1: 'HUR KÄNDES DET ATT SPELA IDAG?',
                question2: 'HUR KÄNNER DU DIG?',
                question3: 'SKULLE DU VILJA SPELA IGEN?'
            },
            answerBeforeAfter: {
                textContent1: 'DÅLIGT',
                textContent2: 'SÅDÄR',
                textContent3: 'BRA',
                imgAlt1: 'widget-dåligt',
                imgAlt2: 'widget-sådär',
                imgAlt3: 'widget-bra',

                answersSlider: {
                    textContent1: 'JÄTTEDÅLIGT',
                    textContent2: 'DÅLIGT',
                    textContent3: 'SÅDÄR',
                    textContent4: 'BRA',
                    textContent5: 'JÄTTEBRA',
                    imgAlt1: 'widget-jättedåligt',
                    imgAlt2: 'widget-dåligt',
                    imgAlt3: 'widget-sådär',
                    imgAlt4: 'widget-bra',
                    imgAlt5: 'widget-jättebra'
                }
            },
            answerFull: {
                answer1: {
                    textContent1: 'DÅLIGT',
                    textContent2: 'SÅDÄR',
                    textContent3: 'BRA',
                    imgAlt1: 'smiley-dåligt',
                    imgAlt2: 'smiley-sådär',
                    imgAlt3: 'smiley-jättebra'
                },
                answer2: {
                    textContent1: 'TRÖTT',
                    textContent2: 'SÅDÄR',
                    textContent3: 'PIGG',
                    imgAlt1: 'smiley-trött',
                    imgAlt2: 'smiley-sådär',
                    imgAlt3: 'smiley-pigg'
                },
                answer3: {
                    textContent1: 'NEJ',
                    textContent2: 'KANSKE',
                    textContent3: 'JA',
                    imgAlt1: 'smiley-dåligt',
                    imgAlt2: 'smiley-sådär',
                    imgAlt3: 'smiley-jättebra'
                }
            }
        },
        evaluationEnd: {
            h1: 'TACK FÖR DITT SVAR',
            imgAltA: 'klart',
            btnTextFull: 'NU ÄR DET SLUT, TACK FÖR IDAG',
            startBtn: 'START',
            backBtn: 'ÄNDRA SVAR'
        },
        endCurrentModal: {
            yesBtn: 'JA, AVSLUTA',
            noBtn: 'NEJ, FORTSÄTT',
            h1: 'VILL DU AVBRYTA INCHECKNINGEN',
            confirmationTextContent: 'INCHECKNING AVBRUTEN'
        },
        endModal: {
            yesBtn: 'JA',
            noBtn: 'NEJ',
            h1: 'VILL DU AVSLUTA OCH SPARA ( %{answerCount} ) SVAR?',
            confirmationTextContent: 'TACK! ( %{answerCount} ) SVAR HAR SPARATS'
        },
        backForwardButtonBox: {
            endBtn: 'AVSLUTA'
        }
    },

    //Auth and Login Pages
    logIn: {
        form: {
            emailLabel: 'E-postadress',
            passwordLabel: 'Lösenord',
            loginBtn: 'Logga in',
            validation: {
                nonValidEmail: 'Ogiltig e-postadress',
                promptEmail: 'Fyll i din e-postadress',
                promptPassword: 'Fyll i ditt lösenord',

                alerts: {
                    general: 'Det finns fel i formuläret nedan',
                    emailPassword: 'Ogiltig e-postadress eller lösenord',
                    fail: 'Inloggningen misslyckades...'
                }
            }
        },
        account: {
            forgotPasswordBtn: 'Glömt lösenord?',
            registerAccountBtn: 'Skapa nytt konto'
        }
    },

    requestPasswordReset: {
        heading: 'Glömt ditt lösenord?',
        paragraph: 'Fyll i din e-postadress så skickar vi en länk för att du ska kunna välja ett nytt lösenord.',
        backToLoginBtn: 'Tillbaka till Logga in',
        form: {
            emailLabel: 'E-postadress',
            continueBtn: 'Fortsätt',
            validation: {
                nonValidEmail: 'Ogiltig e-postadress',
                promptEmail: 'Fyll i din e-postadress',
                continueBtn: 'Fortsätt',

                alerts: {
                    success: 'Vi har skickat en länk till %{email}. Klicka på länken och följ sedan instruktionerna i det nya fönstret som öppnas. Om inget mail dyker upp, se till att kolla i skräppost-mappen.',
                    error: 'Det finns fel i formuläret nedan'
                }
            }
        }
    },

    resetPassword: {
        heading: 'Välj ditt nya lösenord',
        backToLoginBtn: 'Tillbaka till Logga in',
        form: {
            newPasswordLabel: 'Nytt Lösenord',
            savePasswordBtn: 'Spara Lösenord',
            validation: {
                nonValidPassword: 'Måste vara mins 8 karaktärer',
                alerts: {
                    expiredLink: `Länken för att återställa lösenordet har gått ut, vänligen gör en ny förfrågan om att återställa lösenordet`,
                    brokenLink: `Länken för att återställa lösenordet är antingen korrupt eller har redan använts, vänligen gör ny förfrågan om att återställa lösenordet`,
                    success: 'Nya lösenordet har sparats',
                    error: 'Misslyckades att sätta nytt lösenord',
                    general: 'Det finns fel i formuläret nedan'
                }
            }
        }
    },

    signUp: {
        backToLoginBtn: 'Tillbaka till Logga in',
        form: {
            nameLabel: 'Namn (valfri)',
            emailLabel: 'E-postadress',
            passwordLabel: 'Lösenord',
            createAccountBtn: 'Skapa konto',
            validation: {
                nonValidName: 'Max 50 karaktärer långt',
                nonValidEmail: 'Ogiltig e-postadress',
                nonValidPassword: 'Måste vara minst 8 karaktärer',
                required: 'Obligatorisk',

                alerts: {
                    general: 'Det finns fel i formuläret nedan',
                    emailDuplicate: 'Det finns redan ett konto kopplat till e-postadressen',
                    passwordWeak: 'Lösenordet är för svagt eller vanligt, välj ett annat lösenord',
                    success: 'Skapade användare',
                    fail: 'Misslyckades att skapa användare...'
                }
            }
        }
    },

    activateAccount: {
        heading: 'Ditt konto är inte kopplat till någon licens ännu',
        paragraph: 'För att aktivera ditt konto och ansluta till en licens, ange aktiveringskoden för licensen nedan.',
        paragraphLoading: 'Laddar',
        noActivationCodeBtn: 'Har du ingen aktiveringskod?',
        backToLoginBtn: 'Tillbaka till Logga in',
        form: {
            activateBtn: 'aktivera',
            activationCodeLabel: 'Aktiveringskod',
            validation: {
                alerts: {
                    success: 'Aktiveringen lyckades',
                    error: `Något gick fel vid aktiveringen, testa igen eller kontakta oss på Funki om problemet kvarstår`,
                    nonValidCode: 'Den angivna aktiveringskoden är ogitilg'
                }
            }
        }
    },

    //Various
    loading: {
        paragraph: 'Laddar...'
    },
    category: {
        all: 'Alla',
        instrument: 'Instrument',
        relax: 'Avslappning',
        electronic: 'Elektronisk',
        holiday: 'Högtid',
        religion: 'Religion',
        animal: 'Djur',
        seasons: 'Årstider',
        society: 'Samhälle',
        humanbeing: 'Människa',
        nature: 'Natur',
        percussion: 'Slagverk',
        student: 'Student',
        song: 'Visa',
        activityconcept: 'Lektionskoncept',
        C: 'C',
        D: 'D',
        E: 'E',
        F: 'F',
        G: 'G',
        A: 'A',
        B: 'B'
    }
}
